import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui's class merger: concatenates conditionally, then lets
 * tailwind-merge resolve conflicts so a `className` prop from a caller wins
 * over the component's own utility of the same family.
 */
export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}
